import { create } from "zustand";

export const spinnerStore = create((set) => ({
  isLoading: false,
  loadingText: "",
  showSpinner: (text = "") => set({ isLoading: true, loadingText: text }),
  hideSpinner: () => set({ isLoading: false, loadingText: "" }),
}));
